export type FetchNewTokenDataOptions = {
  accountId?: string
  requireAccountId?: boolean
  url?: string
  useOauthToken?: boolean
  useJWT?: boolean
  useRefreshJWT?: boolean
  useScope?: boolean
}

export type TokenDataKey = 'accountId' | 'jwt' | 'jwtExpiresAt' | 'refreshJWT' | 'refreshJWTExpiresAt' | 'oauthToken'

export const isTokenDataKey = (val: string): val is TokenDataKey => ['accountId', 'jwt', 'jwtExpiresAt', 'refreshJWT', 'refreshJWTExpiresAt', 'oauthToken'].includes(val)

export type TokenData = {
  accountId?: string,
  jwt?: string
  jwtExpiresAt?: number
  refreshJWT?: string
  refreshJWTExpiresAt?: number,
  oauthToken?: string
}
